import { get, post } from '@/services/axios'
import portalHttp from '@/services/portal/request'
import {
    NavListState,
    pageConfig,
    PageHeader,
    PageClassifyNav,
    PageCourseGroup,
    PageRichText,
    FooterConfigState
} from '@/constant/computerType'
// 导航返回信息
interface NavigationInfoCallback {
    is_show_search: string
    logo_url: string
    datas: Array<NavListState>
}
// 门户接口
class NavigationInfo {
    // 保存微页面详情数据(编辑)
    savePageConfig(params:Array<pageConfig | PageHeader | PageClassifyNav | PageCourseGroup | PageRichText>) {
        return post('/Portal/MicroPage/saveData', params)
    }
    // 获取指定的微页面详情(编辑)
    getPageConfig(params: { micro_page_id: string }) {
        return post<Array<pageConfig | PageHeader | PageClassifyNav | PageCourseGroup | PageRichText>>('/Portal/MicroPage/getData', params)
    }
    // 获取导航配置
    getNavigationInfo(params: { microid: string }) {
        return portalHttp.get<NavigationInfoCallback>('/Portal/NoAuth/getNavigationInfo', params)
    }
    // 获取导航配置
    getFootInfo(params: { microid: string }) {
        return portalHttp.get<FooterConfigState>('/Portal/NoAuth/getFootInfo', params)
    }
    // 获取页面详情
    getPageDetail(params: { id: string }) {
        return portalHttp.get('/Portal/NoAuth/index', params)
    }
    // 门户搜索全部课程 | 课程查看全部（无鉴权）
    getCourseAllSearch(params: { microid: string; id: string; catid:string; page: number; limit: number }) {
        return portalHttp.get('/Portal/NoAuth/getCourseAllSearch', params)
    }
    // 获取分类列表（无鉴权）
    getClassification(params: { microid: string }) {
        return portalHttp.get('/Portal/NoAuth/getClassification', params)
    }
    // 获取课程列表（无鉴权）
    getCourseList(params: { id: string; type: string, microid: string }) {
        return portalHttp.get('/Portal/NoAuth/getCourseList', params)
    }
    // 获取课程详情目录结构（无鉴权）
    getChapterList(params: { id: string; type: string }) {
        return portalHttp.get('/Portal/NoAuth/getChapterList', params)
    }
    // 获取课堂派课程状态（需要前台登录状态）
    getCourseState(params: { courseid: string }) {
        return portalHttp.post<{
            info: string;
            // 1-暂未开放 | 2-立即报名 | 3-开始学习 | 4-继续学习 | 5-学习回顾
            state: number
        }>('/Portal/NoAuth/getCourseState', params)
    }
    // 机构加课接口（需前台登录使用）
    joinCourse(params: { courseid: string }) {
        return portalHttp.post('/Portal/NoAuth/joinCourse', params)
    }
    // 获取主题配置 （无鉴权）
    getThemeSettings(params: { microid: string }) {
        return portalHttp.get<{
            coid: string
            id: number
            styleColor: string
            favicon: string
            _id: string
        }>('/Portal/NoAuth/themestting', params)
    }
}

const portalApi = new NavigationInfo()
export default portalApi
